import { addDocument, updateSelectedDateDV, updateselectedInternalCode, updateSelectedPickupLocation, updateSelectedtruckerCode, updateSelectedtruckerId, updateSelectedTruckerName, updateSelectedemptyYardName } from '../../instructionSlice/DOExtensionSlice';
import { AESDecrypt, AESEncrypt } from '../../../../../../encrypt-util';
import { AppDispatch, RootState } from '../../../../template/store';
import { approveRejectDoExtension, getCFSNameList, getTrukerNameList, getUnpaidInvoice } from '../../../../dashboard/actions/instruction';
import { Button, Form } from 'react-bootstrap';
import { checkPickupLocationValidity, isEmptyYardDisabledByUnstuffing } from '../utils/doExtensionUtils';
import { clearUnpaidData } from '../../../../crrpop/InvoiceUnpaidSlice';
import { Controller, useFormContext } from 'react-hook-form';
import { faAdd, faCheck, faEdit, faFolder, faInfoCircle, faRedo, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getDateFormat } from '../../../../../../helpers/dateFormat';
import { getInstructionList } from '../../../../dashboard/actions/instruction';
import { getReleaseInstructionCountryConfig } from '../config';
import { getUnprefixedPathname } from '../../../../../../helpers/utils';
import { ReleaseInstructionConfigContext, ReleaseInstructionState } from '../DoExtension';
import { setDirty } from '../../../../formDirtySlice';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { updateDashbaordRefresh } from '../../../../../common/components/DataTable/slices/DataTable';
import { useAsyncDebounce } from 'react-table';
import { useBackNavigation } from '../../../../../../hooks/BackNavigation';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';
import CheckListTable from './DataTables/CheckListTable';
import DatePicker from 'react-datepicker';
import infiniteLoop from '../../../../../../assets/img/animated-icons/infinite-loop.json';
import LinerReleaseAttachmentTable from './DataTables/LinerReleaseAttachmentTable';
import Lottie from 'lottie-react';
import React, { BaseSyntheticEvent, Dispatch, forwardRef, RefObject, SetStateAction, useContext, useEffect, useImperativeHandle, useMemo } from 'react';
import ReleaseAttachmentDataTable from './DataTables/ReleaseAttachmentDataTable';
import ReleaseInstructionTable from './DataTables/ReleaseInstructionTable';
import ReleasePopTable from './DataTables/ReleasePopTable';
import SnoozedToButton from '../../../../instructionDashboard/components/SnoozedTo';
import useDataCountry from '../../../../../../hooks/useDataCountry';


interface DOExtensionFormProps {
    blCountry: string;
    linerConfig?: any;
    onSubmit: (e?: BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
    setState: React.Dispatch<React.SetStateAction<ReleaseInstructionState>>;
    ShowInvoiceModal: boolean;
    state: ReleaseInstructionState;
    version?: number | null;
}

const ZA_DO_EXTENSION_INSTRUCTION_NOTES = [
    'A Delivery Order (DO) Extension Instruction can only be submitted after requesting a storage invoice',
    'Please upload proof of payment via the Invoice Dashboard for any outstanding invoices to prevent delays or rejection of your container release.',
    'The carrier will proceed once all required information has been received.',
    'I declare, acting with proper authorization of and on behalf of my company, that we are and remain primarily liable for all such freights and charges towards Hapag-Lloyd AG.',
];

const DOExtensionForm = ({ state, setState, ShowInvoiceModal, blCountry, linerConfig, onSubmit, version}: DOExtensionFormProps) => {
    const { blNum, encryptdoc } = useParams();
    const { t } = useTranslation();
    const dataCountry = useDataCountry();
    const decrptdoc = AESDecrypt(encryptdoc);
    const dispatch = useDispatch<AppDispatch>();
    const location = useLocation();

    const blEventId_docInsDashboard: any = useSelector((state: any) => state.dashboard.instructionDashboardList.result.filter((Item: any) => Item.bl_id == AESDecrypt(blNum))[0]?.bl_event_id);
    const blidDocHistory: any = useSelector((state: RootState) => state.documentHistory.data?.[0]?.blId);
    const checkListData = useSelector((state: RootState) => state.doExtension.checkList);
    const data = useSelector((state: RootState) => state.doExtension.data);
    const demurrageForm = useSelector((state: RootState) => state.doExtension.demurrageForm);
    const demurrageFormView = useSelector((state: RootState) => state.doExtension.demurrageFormView);
    const docAttachment = useSelector((state: RootState) => state.doExtension.attData);
    const docList = useSelector((state: RootState) => state.doExtension.docList);
    const dropdownDocList = useSelector((state: RootState) => state.doExtension.dropdownDocList);
    const extensionAttData = useSelector((state: RootState) => state.doExtension.extensionAttData);
    const extensionDocList = useSelector((state: RootState) => state.doExtension.extensionDocList);
    const impHaulage = useSelector((state: RootState) => state.oblDetails.oblForm.haulage);
    const instructionList = useSelector((state: RootState) => state.documentHistory.data);
    const linerDocs = useSelector((state: RootState) => state.doExtension.linerDocs)
    const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
    const oblForm = useSelector((state: RootState) => state.oblDetails.oblForm);
    const pickUpLocation = useSelector((state: RootState) => state.doExtension.pickUpLocation);
    const profileDetails = useSelector((state: RootState) => state.userProfile.profile);
    const rbac = useSelector((state: RootState) => state.userProfile);
    const releaseTypeList = useSelector((state: RootState) => state.invoiceChange.releaseTypeList, shallowEqual);
    const selectedAttachmentName = useSelector((state: RootState) => state.doExtension.selectedAttachmentName);

    const selectedCfsName = useSelector((state: RootState) => state.doExtension.selectedCfsName)
    const selectedDate = useSelector((state: RootState) => state.doExtension.selectedDate);
    const selectedEmptyYardName = useSelector((state: RootState) => state.doExtension.selectedemptyYardName)
    const selectedinternalCode = useSelector((state: RootState) => state.doExtension.selectedinternalCode);
    const selectedLinerId = useSelector((state: RootState) => state.navbarTop.linerId);
    const selectedPickupLocation = useSelector((state: RootState) => state.doExtension.selectedPickupLocation);
    const selectedTruckerCode = useSelector((state: RootState) => state.doExtension.selectedTruckerCode);
    const selectedtruckerId = useSelector((state: RootState) => state.doExtension.selectedtruckerId);
    const selectedTruckerName = useSelector((state: RootState) => state.doExtension.selectedTruckerName);
    const serverFilePath = useSelector((state: RootState) => state.doExtension.selectedFileServerPath);

    const releaseInstructionConfig = useContext(ReleaseInstructionConfigContext);
    const recentId = useSelector((state: RootState) => {
        const arr = state?.documentHistory?.data?.filter(
            (inst) =>
                inst.instructionId == 820 &&
                (inst.event == 'Submitted' || inst.event == 'Draft' || inst.event == 'Not Submitted')
        );
        const recentInst = arr.length <= 0 ? null :
            arr.reduce((a: any, b: any) => (a.blEventId > b.blEventId ? a : b))

        return ['Y', '1', '2', '3', '4', '5', '6'].includes(recentInst?.docStatus ?? '')
            ? null
            : recentInst;
    });
    const newEvent = useMemo(() => recentId?.docStatus?.trim() !== '', [])

console.log(releaseInstructionConfig,'<<releaseInstructionConfig');

    const {
        register,
        setValue,
        setError,
        watch,
        control,
        formState: { errors },
    } = useFormContext();
    const accessGroupLevel = [rbac.rbacDetails.doExtLevelOne, rbac.rbacDetails.doExtLevelTwo, rbac.rbacDetails.doExtLevelThree, rbac.rbacDetails.doExtLevelFour, rbac.rbacDetails.doExtLevelFive, rbac.rbacDetails.doExtLevelSix, rbac.rbacDetails.doExtLevelSeven, rbac.rbacDetails.doExtLevelEight, rbac.rbacDetails.doExtLevelNine, rbac.rbacDetails.doExtLevelTen]
    // const doExtension = watch('doExtension');
    const doExtension = 'Y';
    const currentDocList = extensionDocList ?? [];
    const dropdownDocId = (dropdownDocList ?? []).map((i: any) => i.id);
    const navigate = useNavigate();

    const additionalDocCount = ((currentDocList?.filter((i: any) => (dropdownDocId.includes(i.id)))?.length ?? 0))
    const instructionNotes: string[] = releaseInstructionConfig?.fields?.showDoExtensionInstructionNotes
        ? ZA_DO_EXTENSION_INSTRUCTION_NOTES
        : (t('resource_message:demurrageInstruction').split('\n').filter(Boolean) as string[]);

    const unstuffingTypeValue = watch('unstuffingType');
    const disableEmptyYard = isEmptyYardDisabledByUnstuffing({
        unstuffingTypeValue,
        unstuffingTypeOptions: state.unstuffingTypeOptions,
        releaseInstructionConfig,
    });

    useEffect(() => {
        if (!disableEmptyYard || !selectedEmptyYardName?.value) return;
        if (demurrageFormView.status == 'Completed' || demurrageFormView.status?.includes('Rejected')) return;
        dispatch(updateSelectedemptyYardName({ label: null, value: null }));
    }, [disableEmptyYard, selectedEmptyYardName?.value, demurrageFormView.status, dispatch]);

    const onBack = useBackNavigation();
    



    const onApproveReject = (status: string, type: string) => {
        if (status && type) {

            if (status === 'A' &&
                accessGroupLevel.includes('Y') && checkListData?.some((i: any) => i.isMandatory == 'Y' && i.check == null && i.groupLevel == demurrageFormView.groupLevel)) {
                toast.error('All Check list points need to be marked');
                return
            }

            if (!!linerDocs?.find?.((i) => !['100', 100, '0', 0, '-1', -1].includes(i.loading))) {
                toast.error('Can not approve request with ongoing upload')
                return
            }

            if (status == 'A') {
                const pendingFile = linerDocs?.filter((i) => i.m && !(disableEmptyYard && i.docId == 208))
                    ?.find((i) => (!i.serverPath || !i.fileName || i.loading != 100)
                        && (i.doReleasePdfId == null && i.id == null))

                if (pendingFile) {
                    toast.error(`Please Upload ${pendingFile.name
                        } to Approve the request`)
                    return
                }

                if (rbac.rbacDetails.doExtCfsEmptyName == 'Y') {
                    if ((!!linerDocs?.find((i) => i.docId == 206)?.fileName) !== (!!selectedCfsName.value)) {
                        toast.error(`Please Add ${!!selectedCfsName.value ? linerDocs?.find((i) => i.docId == 206)?.name : 'CFS Name'
                            } to Approve the request`)
                        return
                    } else if (!disableEmptyYard && (!!linerDocs?.find((i) => i.docId == 208)?.fileName) !== (!!selectedEmptyYardName.value)) {
                        toast.error(`Please Add ${!!selectedEmptyYardName.value ? linerDocs?.find((i) => i.docId == 208)?.name : 'Empty Yard Name'
                            } to Approve the request`)
                        return
                    }
                }

            }

            if ((state.showUnstuffingTypeConfig ?? '').toLowerCase() === 'yes') {
                if (!watch('unstuffingType') || watch('unstuffingType') === '0') {
                    setError('unstuffingType', {
                        type: 'manual',
                        message: 'Please select a valid Unstuffing Type',
                    });
                    return;
                }
            }

            const isShowUnstuffingType = ((state.showUnstuffingTypeConfig ?? '').toLowerCase() === 'yes')
            const unstuffingTypeValue = watch('unstuffingType')


            if (status === 'R' && (state.remarks === '' || state.remarks == null)) {
                toast.dark(t('resource_message:remarksMandatory'));
            } else {
                dispatch(
                    approveRejectDoExtension({
                        instructionId: state.dndInstructionId || null,
                        blId: demurrageFormView.blId,
                        country: blCountry,
                        instructionType: type || null,
                        linerRemarks: state.remarks || null,
                        customerRemarks: null,
                        status: status || null,
                        emailTo: demurrageFormView.senderEmail || null,
                        isVerify: !accessGroupLevel.includes('Y') || status === 'R' ? null : `${extensionAttData.list.filter((item) => item.actionBy === profileDetails.email).map((item) => `${item.docId}-${item.isVerify}`)}`,
                        requestType: 820,
                        requestedPartnerId: profileDetails.partnerId,
                        groupLevel: !accessGroupLevel.includes('Y') ? null : demurrageFormView.groupLevel + 1,
                        actionBy: !accessGroupLevel.includes('Y') ? null : profileDetails.email || null,
                        checkList: checkListData?.filter(
                            (i: any) => i.groupLevel == demurrageFormView.groupLevel && i.check != null
                        ).map((item: any) => ({
                            codeId: item.docId,
                            isVerify: item.check,
                            remarks: item.remarks,
                            docType: 8201,
                        })),
                        demurrageInstLinerAttDtls: linerDocs?.map((i) => ({
                            demurrageInstructionLinerAttId: i.id,
                            doReleasePdfId: i.doReleasePdfId,
                            docId: i.docId,
                            filePath: '',
                            fileName: i.fileName,
                            serverFilePath: i.serverPath,
                            tempFileName: i.tempName,
                            tempFilePath: i.filePath
                        })),
                        // actionOn:docVerifyUpdatedTime || null
                        linerId: +selectedLinerId,
                        cfsPartnerId: selectedCfsName.value ? +selectedCfsName.value : null,
                        emptyYardPartnerId: disableEmptyYard ? null : (selectedEmptyYardName.value ? +selectedEmptyYardName.value : null),
                        nextLevel: watch("selectedApprovalLevel") ? watch("selectedApprovalLevel") : null,
                        unstuffing: (isShowUnstuffingType && unstuffingTypeValue) ? unstuffingTypeValue : '',
                        version: version,
                    })
                )
                    .unwrap()
                    .then((response: any) => {
                        toast.success(response?.responseMsg);
                        dispatch(updateDashbaordRefresh(true))
                    })
                    .catch((error: any) => {
                        toast.error(error);
                    });

                //update instruction list and redirect to previous page
                setTimeout(() => {
                    dispatch(
                        getInstructionList({
                            blNum: AESDecrypt(blNum),
                            country: profileDetails.partnerType == "liner" ? dataCountry : blCountry
                        })
                    );
                }, 3000);
                onBack();
            }
        }
    };



    const setSelectedContainerInput: Dispatch<SetStateAction<string>> = (updater) => {
        const nextValue =
            typeof updater === 'function'
                ? (updater as (prev: string) => string)(state.selectedContainerInput)
                : updater;
        setState(prev => ({ ...prev, selectedContainerInput: nextValue }));
    };
    const setTruckerCodeArray: Dispatch<SetStateAction<any[]>> = (updater) => {
        const nextValue =
            typeof updater === 'function'
                ? (updater as (prev: any[]) => any[])(state.truckerCodearray || [])
                : updater;
        setState(prev => ({ ...prev, truckerCodearray: nextValue }));
    };
    const promiseOptions = (inputValue: string) =>
        new Promise<any[]>((resolve) => {
            setTimeout(() => {
                dispatch(getTrukerNameList({ name: inputValue, country: blCountry, linerId: linerId }))
                    .unwrap()
                    .then((v: any) => {
                        resolve(v);
                    });
            }, 2000);
        });

    const PickupLocationValidityFlag = checkPickupLocationValidity(
        data.list,
        selectedPickupLocation,
        selectedTruckerName,
        selectedDate,
        {
            showPickupLocationFields: state.showPickupLocationFields,
            impHaulage,
            releaseInstructionConfig,
        }
    );

    const setLoadingFileState: Dispatch<SetStateAction<Record<string, number>>> = (
        updater
    ) => {
        const nextValue =
            typeof updater === 'function'
                ? (updater as (prev: Record<string, number>) => Record<string, number>)(state.loadingFileState)
                : updater;
        setState(prev => ({ ...prev, loadingFileState: nextValue }));
    };


    const approveRejectAccess = useMemo(() => !(instructionList.filter(
        (v: any) =>
            v?.docId === demurrageFormView?.dndInstructionId
    ).map((u: any) => u?.event === 'Completed').includes(true)
        || (demurrageFormView.status == 'Completed' || demurrageFormView.status?.includes('Rejected'))
        ||
        !(accessGroupLevel[demurrageFormView.groupLevel] == 'Y' || !accessGroupLevel.includes('Y'))
        ||
        dataCountry !== blCountry || rbac.rbacDetails.doExtApproveReject !== 'Y')
        , [instructionList, demurrageFormView, dataCountry,
            blCountry, rbac.rbacDetails.doExtApproveReject, demurrageFormView.status])

    const setSubmitOn = (value: boolean) => setState((prev: ReleaseInstructionState) => ({ ...prev, submitOn: value }));
    const setReleaseType = (value: string) =>
        setState(prev => ({ ...prev, releaseType: value }));
    const _onReleaseTypeChange = useAsyncDebounce((value: string) => {
        setState(prev => ({ ...prev, releaseType: value }));
    }, 200);

    const setUserRemarks = (value: string) =>
        setState(prev => ({ ...prev, userRemarks: value }));
    const setRemarks = (value: string) =>
        setState(prev => ({ ...prev, remarks: value }));
    const setDoUploadStatus = (value: string) =>
        setState(prev => ({ ...prev, doUploadStatus: value }));
    const setDoIntegrationRemarks = (value: string) =>
        setState(prev => ({ ...prev, doIntegrationRemarks: value }));
    const setIsDraft = (value: boolean) =>
        setState(prev => ({ ...prev, isDraft: value }));
    const setDisableFields = (value: any) =>
        setState(prev => ({ ...prev, disableFields: value }));
    const setIsEdit = (value: boolean) =>
        setState(prev => ({ ...prev, isEdit: value }));
    const setSenderEmail = (value: any) =>
        setState(prev => ({ ...prev, senderEmail: value }));
    const isUnstuffingDisabled = (profileDetails.partnerType === 'customer' && state.disableFields) ||
        (profileDetails.partnerType === 'liner' && !((dataCountry === blCountry &&
            rbac.rbacDetails.doExtApproveReject === 'Y' &&
            !(
                state.isProcessing === 'Y' &&
                !linerDocs?.find((i) => i.docId == 206)?.serverPath &&
                !linerDocs?.find((i) => i.docId == 206)?.id
            )) && !(instructionList
                .filter(
                    (v: any) =>
                        v?.docId === demurrageFormView?.dndInstructionId
                )
                .map((u: any) => u?.event === 'Completed')
                .includes(true)
                ||
                (demurrageFormView.status == 'Completed' || demurrageFormView.status?.includes('Rejected'))) && ((accessGroupLevel[demurrageFormView.groupLevel] == 'Y' || !accessGroupLevel.includes('Y')))))
    const locationOptions = (inputValue: string) =>
        new Promise<any[]>((resolve) => {
            setTimeout(() => {
                dispatch(getCFSNameList({ country: blCountry, name: inputValue }))
                    .unwrap()
                    .then((v: any) => {
                        resolve(v);
                    });
            }, 2000);
        });


    const openDoGeneratedDialog = () => setState(prev => ({ ...prev, showDoGeneratedDialog: true }));

    const resetForm = () => {
        setState(prev => ({ ...prev, senderEmail: '' }));
        dispatch(updateSelectedDateDV({ intended: null }));
        dispatch(updateSelectedtruckerCode({ truckerCode: '' }));
        dispatch(updateSelectedPickupLocation({}));
        dispatch(updateSelectedTruckerName({}));
        dispatch(updateSelectedtruckerId({}));
        setState(prev => ({ ...prev, userRemarks: '' }));
        if(!state.isSavedDoNumber){
            setValue("doNumber", "")
        }
        setValue("unstuffingType", "0")
    };

    const setDoGeneratedAMS = (
        updater: 'Y' | 'N' | ((prev: 'Y' | 'N') => 'Y' | 'N')
    ) => {
        const nextValue =
            typeof updater === 'function'
                ? (updater as (prev: 'Y' | 'N') => 'Y' | 'N')(state.doGeneratedAMS)
                : updater;
        setState(prev => ({ ...prev, doGeneratedAMS: nextValue }));
    };


    return (
        <Form onSubmit={(e) => {
            e.preventDefault()
            if (ShowInvoiceModal) {
                setSubmitOn(true)
                return;
            }
            onSubmit()
        }} autoComplete='off'>
            <div className='row'>
                {instructionNotes.length > 0 && (
                    <div className='col-lg-12 mb-1'>
                        <div className='col-lg-12 mb-1'>
                            <Form.Label style={{ color: '#f5822a' }}>
                                <ul style={{ paddingLeft: '15px' }}>
                                    {instructionNotes.map((note, index) => (
                                        <li key={`${index}-${note}`}>{note}</li>
                                    ))}
                                </ul>
                            </Form.Label>
                        </div>
                    </div>
                )}


                {releaseInstructionConfig?.fields?.showMalaysiaPODField && (
                    <div className='col-lg-6 mb-3'>
                        <Form.Group controlId='carrierHaulage.pod'>
                            <Form.Label className='fs--1'>
                                {t('resource_3:Port_of_destination')}
                                <span>
                                    {' '}
                                    <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        title=' '
                                        className='me-2'
                                    />
                                </span>
                            </Form.Label>
                            <Form.Control
                                type='POD'
                                size='sm'
                                //   disabled={state.disableFields}
                                disabled={true}
                                value={oblForm?.pod || ''}
                            />
                            <div className='invalid-feedback'></div>
                        </Form.Group>
                    </div>
                )}

                {releaseInstructionConfig?.fields.showReleaseType ? (
                    <div className='col-lg-5 mb-3 d-none' style={{ zIndex: 15 }}>
                        <Form.Group controlId='invoiceChanges.releaseType'>
                            <Form.Label className='fs--1'>
                                <span className='mandatory'>*</span>
                                {t('resource_2:releaseType')}&nbsp;
                            </Form.Label>
                            <Form.Select
                                aria-label={t('resource_2:releaseType')}
                                {...register('releaseType')}
                                className='fs--1'
                                disabled={state.disableFields}
                                value={state.releaseType}
                                onChange={(e) => {
                                    setReleaseType(e.target.value);
                                    _onReleaseTypeChange(e.target.value);
                                    dispatch(setDirty());
                                }}>
                                {releaseTypeList.map((option: any) => (
                                    <option key={option.value} value={option.value}>
                                        {option.text}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </div>
                ) : (
                    ''
                )}
                {releaseInstructionConfig?.fields.hideSenderEmail ? (
                    ''
                ) : (
                    <div className='col-lg-6 mb-3'>
                        <Form.Group controlId='carrierHaulage.senderEmail'>
                            <Form.Label className='fs--1'>
                                <span className='mandatory'>*</span>
                                {t('resource_2:senderEmail')}
                                <span>
                                    {' '}
                                    <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        title='We will send the invoice for the demurrage within some minutes to this email address.'
                                        className='me-2'
                                    />
                                </span>
                            </Form.Label>
                            <Form.Control
                                {...register('senderEmail')}
                                className={`fs--1 form-control ${errors.senderEmail ? 'is-invalid' : ''
                                    }`}
                                type='email'
                                onChange={(e) => {
                                    setSenderEmail(e.target.value);
                                    dispatch(setDirty());
                                }}
                                size='sm'
                                disabled={state.disableFields}
                                value={
                                    state.disableFields
                                        ? demurrageFormView?.senderEmail || ''
                                        : state.senderEmail
                                }
                            />
                            <div className='invalid-feedback'>
                                {errors.senderEmail?.message?.toString()}
                            </div>
                        </Form.Group>
                    </div>
                )}
                {profileDetails.partnerType == 'liner' ? (
                    <div className='col-lg-6 mb-3' style={{ zIndex: 1 }}>
                        <Form.Group controlId='carrierHaulage.requestedPartnerNm'>
                            <Form.Label className='fs--1'>
                                <span className='mandatory'>*</span>
                                {t('resource_2:companyName')}
                                <span>
                                    {' '}
                                    {/* <FontAwesomeIcon
                        icon={faInfoCircle}
                        title='We will send the invoice for the demurrage within some minutes to this email address.'
                        className='me-2'
                      /> */}
                                </span>
                            </Form.Label>
                            <Form.Control
                                {...register('requestedPartnerName')}
                                className={`fs--1 form-control ${errors.requestedPartnerName ? 'is-invalid' : ''
                                    }`}
                                type='text'
                                // onChange={(e) => setSenderEmail(e.target.value)}
                                size='sm'
                                disabled={state.disableFields}
                                value={
                                    state.disableFields
                                        ? demurrageFormView?.requestedPartnerName || ''
                                        : state.requestedPartnerName
                                }
                            />
                            <div className='invalid-feedback'>
                                {errors.requestedPartnerName?.message?.toString()}
                            </div>
                        </Form.Group>
                    </div>
                ) : (
                    <></>
                )}

                {/* PIL MZ - New Feature: Hide Pickup Location */}
                {(!state.disableFields && releaseInstructionConfig?.fields?.showPickupLocation && state.showPickupLocationFields) ? (
                    <div className='col-lg-6 mb-3 '>
                        <Form.Group>
                            <Form.Label className='fs--1'>
                                {t('resource_7:pickupLocationForAllContainer')}{' '}
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    title='Change Pickup location for all conatainer'
                                    className='me-2'
                                />
                            </Form.Label>
                            <div>
                                {releaseInstructionConfig?.fields?.showPickupLocationAsyncSelect || releaseInstructionConfig?.fields?.pickupLocationColumnWide ?
                                    <div style={{ zIndex: 999 }}>
                                        <AsyncSelect
                                            menuPortalTarget={document.body}

                                            classNames={{
                                                control: (state) => {
                                                    return `dropControl fs--1 asyncDropField m-0 p-0
                          form-control ${state.isDisabled ? 'disabledField' : ''}
                          ${state.isFocused ? 'focusField' : ''}`;
                                                },
                                            }}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                control: () => ({}),
                                            }}
                                            cacheOptions
                                            onChange={(e: any) => {
                                                let containers: any = {};
                                                let emptyContainers: any = {};
                                                let pickupDateConatiner: any = {};

                                                for (let k of data.list) {
                                                    if (k?.containerNo) {
                                                        if (
                                                            e?.cfsName ===
                                                            selectedPickupLocation?.[k?.containerNo]
                                                        ) {
                                                        } else {
                                                            containers[k.containerNo] = e?.cfsName;
                                                            emptyContainers[k.containerNo] = null;
                                                        }
                                                    }
                                                    if (!e?.cfsName) {
                                                        pickupDateConatiner[k.containerNo] = null;
                                                    }
                                                }

                                                dispatch(
                                                    updateSelectedPickupLocation({
                                                        ...selectedPickupLocation,
                                                        ...containers,
                                                        location: e?.cfsName,
                                                    })
                                                );
                                                dispatch(
                                                    updateSelectedTruckerName({
                                                        ...selectedTruckerName,
                                                        ...emptyContainers,
                                                    })
                                                );
                                                dispatch(
                                                    updateSelectedtruckerId({
                                                        ...selectedtruckerId,
                                                        ...emptyContainers,
                                                    })
                                                );
                                                dispatch(
                                                    updateselectedInternalCode({
                                                        ...selectedinternalCode,
                                                        ...emptyContainers,
                                                    })
                                                );
                                                dispatch(
                                                    updateSelectedDateDV({
                                                        ...selectedDate,
                                                        ...pickupDateConatiner,
                                                    })
                                                );
                                                dispatch(setDirty());
                                            }}
                                            value={{
                                                label: selectedPickupLocation?.location || '',
                                                value: selectedPickupLocation?.location || '',
                                            }}

                                            loadOptions={locationOptions}
                                            isDisabled={state.disableFields}
                                            isClearable={true}
                                            noOptionsMessage={({ inputValue }) => {
                                                if (!inputValue) return 'Type to search';
                                                return 'No options';
                                            }}
                                        />
                                    </div>
                                    : <Form.Select
                                        {...register('pickupLocation')}
                                        disabled={state.disableFields}
                                        value={selectedPickupLocation?.location || ''}
                                        onChange={(e) => {
                                            let containers: any = {};
                                            let emptyContainers: any = {};
                                            let pickupDateConatiner: any = {};
                                            if (e.target.value) {
                                                for (let k of data.list) {
                                                    if (k?.containerNo) {
                                                        if (
                                                            e.target.value ===
                                                            selectedPickupLocation?.[k?.containerNo]
                                                        ) {
                                                        } else {
                                                            containers[k.containerNo] = e.target.value;
                                                            emptyContainers[k.containerNo] = null;
                                                        }
                                                        if (e.target.value === '1002') {
                                                            pickupDateConatiner[k.containerNo] =
                                                                selectedDate?.intended;
                                                        } else {
                                                            pickupDateConatiner[k.containerNo] = null;
                                                        }
                                                    }
                                                }
                                            }
                                            dispatch(
                                                updateSelectedPickupLocation({
                                                    ...selectedPickupLocation,
                                                    ...containers,
                                                    location: e.target.value,
                                                })
                                            );
                                            dispatch(
                                                updateSelectedTruckerName({
                                                    ...selectedTruckerName,
                                                    ...emptyContainers,
                                                })
                                            );
                                            dispatch(
                                                updateSelectedtruckerId({
                                                    ...selectedtruckerId,
                                                    ...emptyContainers,
                                                })
                                            );
                                            dispatch(
                                                updateselectedInternalCode({
                                                    ...selectedinternalCode,
                                                    ...emptyContainers,
                                                })
                                            );
                                            dispatch(
                                                updateSelectedDateDV({
                                                    ...selectedDate,
                                                    ...pickupDateConatiner,
                                                })
                                            );
                                            dispatch(setDirty());
                                        }}
                                        className='fs--1 form-control  form-select'>
                                        {
                                            <>
                                                {pickUpLocation.map((option: any) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.text}
                                                    </option>
                                                ))}
                                            </>
                                        }
                                    </Form.Select>}
                            </div>
                        </Form.Group>
                    </div>
                ) : (
                    ''
                )}
                {((state.showUnstuffingTypeConfig ?? "").toLowerCase() == 'yes') && (
                    <div className='col-lg-6 mb-3'>
                        {/* PIL MZ - New Feature: Force show Unstuffing field */}
                        <Form.Group>
                            <Form.Label className='fs--1'>
                                <span className="mandatory">*</span>
                                Unstuffing Type For All Container
                            </Form.Label>
                            <Form.Select
                                {...register("unstuffingType")}
                                className={`fs--1 form-control form-select ${errors.unstuffingType ? 'is-invalid' : ''
                                    }`}
                                style={{ fontSize: "12px" }}
                                disabled={isUnstuffingDisabled}
                            >
                                {state.unstuffingTypeOptions?.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.text}
                                    </option>
                                ))}
                            </Form.Select>
                            <div className='invalid-feedback'>
                                {errors.unstuffingType?.message?.toString()}
                            </div>
                        </Form.Group>
                    </div>)}

                {releaseInstructionConfig?.fields?.showIntendedDateAllContainersAlways ||
                    (!state.disableFields && releaseInstructionConfig?.fields?.showIntendedDateAllContainersWhenEditable ) ||
                    (releaseInstructionConfig?.fields?.intendedDateMyPenang && oblForm?.pod === 'MYPEN') ? (
                    <div className='col-lg-6 mb-3'>
                        <Form.Group controlId='carrierHaulage.IntendedDate'>
                            <Form.Label className='fs--1'>
                                {releaseInstructionConfig?.fields?.intendedDateAllContainersLabel ??
                                    t('resource_7:IntendedDateForAllContainer')}{' '}
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    title='We will calculate the storage/demurrage up to this date.'
                                    className='me-2'
                                />
                            </Form.Label>
                            <div className='releaseDate'>
                                <DatePicker
                                    selected={selectedDate?.intended}
                                    onChange={(date) => {
                                        let containers: any = {};
                                        if (date) {
                                            for (let k of data.list) {
                                                if (k?.containerNo) {
                                                    if (releaseInstructionConfig?.fields?.showIntendedDateAllContainersWhenEditable) {
                                                        if (
                                                            selectedPickupLocation?.[k?.containerNo] !==
                                                            '1001'
                                                        ) {
                                                            containers[k.containerNo] = date;
                                                        } else {
                                                            containers[k.containerNo] = null;
                                                        }
                                                    } else {
                                                        containers[k.containerNo] = date;
                                                    }
                                                }
                                            }
                                        }

                                        dispatch(
                                            updateSelectedDateDV({
                                                ...selectedDate,
                                                ...containers,
                                                intended: date,
                                            })
                                        );
                                        dispatch(setDirty());
                                    }}
                                    className='fs--2 form-control'
                                    timeIntervals={5}
                                    dateFormat={getDateFormat()}
                                    isClearable={true}
                                    popperProps={{
                                        strategy: 'fixed',
                                    }}
                                    minDate={new Date()}
                                    disabled={state.disableFields}
                                />
                            </div>
                        </Form.Group>
                    </div>
                ) : (
                    ''
                )}

                {releaseInstructionConfig?.fields?.showIntendedDateContainerField ? (
                    <div className='col-lg-6 mb-3' style={{ zIndex: 1 }}>
                        <Form.Group controlId='carrierHaulage.IntendedDate'>
                            <Form.Label className='fs--1'>
                                {releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels && oblForm?.pod === 'MYPKG'
                                    ? t('resource_7:ledger_acc_number') + ' '
                                    : releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels && oblForm?.pod === 'MYPEN'
                                        ? t('resource_5:dic_number') + ' '
                                        : releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels &&
                                            (oblForm?.pod === 'MYPGU' || oblForm?.pod === 'MYTPP')
                                            ? t('resource_7:forward_agent_code') + ' '
                                            : releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels && oblForm?.pod === 'MYKUA'
                                                ? t('') + ' '
                                                : t('resource_7:IntendedDateForAllContainerSG') + ' '}
                            </Form.Label>
                            <div>
                                {
                                    <Form.Control
                                        size='sm'
                                        type='text'
                                        className={
                                            oblForm?.pod === 'MYKUA' && blCountry === 'MY'
                                                ? 'd-none'
                                                : 'd-block'
                                        }
                                        onChange={(e) => {
                                            let containers: any = {};

                                            for (let k of data.list) {
                                                if (k?.containerNo) {
                                                    containers[k.containerNo] = e.target.value;
                                                }
                                            }

                                            dispatch(
                                                updateSelectedtruckerCode({
                                                    ...selectedTruckerCode,
                                                    ...containers,
                                                    // intended: date,
                                                    truckerCode: e.target.value,
                                                })
                                            );
                                            dispatch(setDirty());
                                        }}
                                        value={selectedTruckerCode?.truckerCode}
                                        disabled={state.disableFields}
                                    />
                                }
                            </div>
                        </Form.Group>
                    </div>
                ) : (
                    ''
                )}

                
                    {releaseInstructionConfig?.fields?.showDoNumber !== false &&
                        !(+linerId === 1 && blCountry === 'KE') && (
                        <div className='col-lg-6 mb-3'>
                            <span className="mandatory">*</span>
                            <Form.Label className='fs--1'>
                                DO No
                            </Form.Label>
                            {
                                <Form.Control
                                    {...register('doNumber')}
                                    value={watch('doNumber')}
                                    className={`fs--1 ${errors.doNumber?.message?.toString() ? "is-invalid" : ""}`}
                                    disabled={state.disableFields || state.isSavedDoNumber}
                                >
                                </Form.Control>
                            }
                            <div className='invalid-feedback d-block'>
                                {errors.doNumber?.message?.toString()}
                            </div>
                        </div>
                    )}
               
                 
                {/* Right column */}
                {/* <div className='col-lg-6  mb-3 ' style={{ zIndex: 1 }}>

                  {blCountry === 'MZ' && doExtension == 'Y' && (
                    <div style={{ minWidth: 350, maxWidth: 450 }}>
                      <Form.Group controlId="overStayExtension.needExtensionFor">
                        <Form.Label className="fs--1 mb-1">
                          {t('resource_5:needExtensionForAllContainer')}
                        </Form.Label>
                        <Form.Select
                          value={String(allSameValue)}
                          disabled={state.disableFields}
                          onChange={e => {
                            const newValue = e.target.value;
                            const keys = data?.list?.map((item: any) => item.containerNo) || [];
                            setSelectedNeedExtensionFor((prev: any) => {
                              const newObj: { [key: string]: string } = {};
                              keys.forEach(key => {
                                newObj[key] = newValue;
                              });
                              return newObj;
                            });
                            keys.forEach(containerNo => {
                              dispatch(updateSelectedContainerNo({ containerNo, needExtensionFor: newValue }));
                            });
                            dispatch(setDirty());
                          }}
                        >
                          {extensionTypeOption.map((option: any) => (
                            <option key={option.value} value={String(option.value)}>
                              {option.text}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  )}
                </div> */}

                {!state.disableFields && releaseInstructionConfig?.fields?.showTruckerNameForAllContainer ? (
                    <div className='col-lg-6 mb-3'>
                        <Form.Group>
                            <Form.Label className='fs--1'>
                                {t('resource_7:truckerNameForAllContainer')}{' '}
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    title='Change trucker name for all conatainer'
                                    className='me-2'
                                />
                            </Form.Label>
                            <div style={{ zIndex: 999 }}>
                                <AsyncSelect
                                    menuPortalTarget={document.body}
                                    noOptionsMessage={({ inputValue }) => {
                                        return inputValue ? 'No options' : 'Type to search';
                                    }}
                                    classNames={{
                                        control: (state) => {
                                            return `dropControl fs--1 asyncDropField m-0 p-0
                          form-control ${state.isDisabled ? 'disabledField' : ''
                                                }
                          ${state.isFocused ? 'focusField' : ''}`;
                                        },
                                    }}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        control: () => ({}),
                                    }}
                                    cacheOptions
                                    onChange={(e: any) => {
                                        let containers: any = {};
                                        let emptyContainers: any = {};
                                        let truckerIdConatiner: any = {};
                                        let pickupDateConatiner: any = {};
                                        if (e?.truckerName) {
                                            for (let k of data.list) {
                                                if (k?.containerNo) {
                                                    if (
                                                        selectedPickupLocation?.[k?.containerNo] !==
                                                        '1002' &&
                                                        !(
                                                            impHaulage === 'Carrier Haulage' &&
                                                            releaseInstructionConfig?.fields?.carrierHaulageTruckerDisabled
                                                        )
                                                    ) {
                                                        containers[k.containerNo] = e?.truckerName;
                                                        emptyContainers[k.containerNo] = e?.internalCode;
                                                        truckerIdConatiner[k.containerNo] =
                                                            e?.truckerId;
                                                    }
                                                    if (
                                                        selectedPickupLocation?.[k?.containerNo] ===
                                                        '1002' || releaseInstructionConfig?.fields?.useIntendedAsPickupDate
                                                    ) {
                                                        pickupDateConatiner[k.containerNo] =
                                                            selectedDate?.intended;
                                                    } else {
                                                        pickupDateConatiner[k.containerNo] = null;
                                                    }
                                                }
                                            }
                                            dispatch(setDirty());
                                        }
                                        dispatch(
                                            updateSelectedTruckerName({
                                                ...selectedTruckerName,
                                                ...containers,
                                                location: e?.truckerName,
                                            })
                                        );
                                        dispatch(
                                            updateSelectedtruckerId({
                                                ...selectedtruckerId,
                                                ...truckerIdConatiner,
                                            })
                                        );
                                        dispatch(
                                            updateselectedInternalCode({
                                                ...selectedinternalCode,
                                                ...emptyContainers,
                                            })
                                        );
                                        dispatch(
                                            updateSelectedDateDV({
                                                ...selectedDate,
                                                ...pickupDateConatiner,
                                            })
                                        );
                                    }}
                                    value={{
                                        label: selectedTruckerName?.location || '',
                                        value: selectedTruckerName?.location || '',
                                    }}
                                    loadOptions={promiseOptions}
                                    isDisabled={
                                        (impHaulage === 'Carrier Haulage' && releaseInstructionConfig?.fields?.carrierHaulageTruckerDisabled)
                                        || state.disableFields
                                    }
                                    isClearable={true}
                                />
                            </div>
                        </Form.Group>
                    </div>
                ) : (
                    ''
                )}
                <ReleasePopTable
                    blCountry={blCountry}
                />

                {profileDetails?.partnerType === 'customer' &&
                    releaseInstructionConfig?.fields?.showUSCAMessage ? (
                    <label className='form-label' style={{ color: '#f5822a' }}>
                        Please submit the Intended Pickup Date only for those
                        containers for which the Demurrage Invoice is needed
                    </label>
                ) : (
                    ''
                )}
                {releaseInstructionConfig && (
                    <ReleaseInstructionTable
                        disableFields={state.disableFields}
                        isEdit={state.isEdit}
                        selectedContainerInput={state.selectedContainerInput}
                        setSelectedContainerInput={setSelectedContainerInput}
                        truckerCodearray={state.truckerCodearray}
                        setTruckerCodeArray={setTruckerCodeArray}
                        releaseInstructionConfig={releaseInstructionConfig}
                        showPickupLocationFields={state.showPickupLocationFields}
                        impHaulage={impHaulage}
                        oblForm={oblForm}
                        blCountry={blCountry}
                    />
                )}

                {releaseInstructionConfig?.fields?.showDocumentAttachmentSection && extensionAttData.list && extensionDocList?.length ? (
                    <div className='col-lg-12 mt-2 mb-2 demmurageTable'>
                        {(!state.disableFields) && <span className='badge bg-secondary mb-2'>
                            {t('resource_message:docInfo')}{' '}
                        </span>}

                        {/*  {tncUrl && (
                    <span className='badge bg-light mb-2' style={{color:'#5e6e82'}}>
                        <a
                          href={tncUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-link ms-3"
                          style={{ color: '#2c7be5', textDecoration: 'none', fontSize:"14px", padding:"0px" }}
                          onMouseOver={e => { e.currentTarget.style.textDecoration = 'underline'; }}
                          onMouseOut={e => { e.currentTarget.style.textDecoration = 'none'; }}
                        >
                          <FontAwesomeIcon icon={faDownload} className="text-warning" style={{ padding: '0px 3px' }} /> 
                            {t('resource_2:clickHere')} 
                        </a> to download Guarantee Form 
                        </span>
                    )}  */}

                        {(!state.disableFields) && !!dropdownDocList?.length && (
                            <div>
                                <Button
                                    variant='falcon-primary'
                                    size='sm'

                                    onClick={() => {
                                        if (!dropdownDocList || dropdownDocList.length === 0) return;


                                        // const rowNumber = crypto.randomUUID();
                                        // const selectedDoc = { rowNumber:rowNumber, ...dropdownDocList[0]};
                                        if (additionalDocCount < 10) {
                                            dispatch(addDocument({ isExtension: true }));
                                        }
                                    }}
                                    disabled={!dropdownDocList?.length || additionalDocCount >= 10}
                                    className=" mb-2"
                                    style={{ width: "max-content" }}
                                >
                                    <FontAwesomeIcon className="me-1" icon={faAdd} /> Documents
                                </Button>
                            </div>
                        )}
                        <ReleaseAttachmentDataTable
                            disableFields={state.disableFields}
                            loadingFileState={state.loadingFileState}
                            setLoadingFileState={setLoadingFileState}
                            accessGroupLevel={accessGroupLevel}
                            doExtension={doExtension}
                        />
                    </div>
                ) : (
                    ''
                )}
                {accessGroupLevel.includes('Y') && checkListData?.length > 0 &&
                    <CheckListTable accessGroupLevel={accessGroupLevel} />
                }
                {releaseInstructionConfig && (
                    <LinerReleaseAttachmentTable
                        accessGroupLevel={accessGroupLevel}
                        attachedFileSize={state.attachedFileSize}
                        approveRejectAccess={approveRejectAccess}
                        releaseInstructionConfig={releaseInstructionConfig}
                        blCountry={blCountry}
                        disableEmptyYard={disableEmptyYard}
                    />
                )}
                {(
                    dataCountry === blCountry &&
                    (state.doGeneratedAmsConfig ?? "") == 'Y' &&
                    profileDetails.partnerType === 'liner' &&
                    rbac.rbacDetails.doExtApproveReject === 'Y'
                ) && (
                        <div className='col-lg-12' style={{ zIndex: 1 }}>
                            <Form.Check
                                type="checkbox"
                                id="do-generated-checkbox"
                                label="DO generated on AMS"
                                checked={state.isProcessing === 'Y' || state.doGeneratedAMS === 'Y'}
                                onChange={() => {
                                    if (state.isProcessing === '') {
                                        openDoGeneratedDialog()
                                    };
                                    setDoGeneratedAMS(prev => (prev === 'Y' ? 'N' : 'Y'));
                                }}
                                disabled={
                                    profileDetails.partnerType != 'liner' ||
                                    !linerDocs?.find((i) => i?.docId == 206) ||
                                    state.isProcessing === 'Y' ||
                                    state.isProcessing === 'N' ||
                                    (demurrageFormView?.status === 'Completed' ||
                                        demurrageFormView?.status?.includes('Rejected')) ||
                                    !(accessGroupLevel[demurrageFormView.groupLevel] === 'Y' || !accessGroupLevel.includes('Y')) ||
                                    instructionList
                                        .filter((v: any) => v?.docId === demurrageFormView?.dndInstructionId)
                                        .map((u: any) => u?.event === 'Completed')
                                        .includes(true)
                                }
                            />
                        </div>
                    )
                }
                {
                    (rbac.rbacDetails.doExtRejectionLevelSelection == 'Y' && state.approvalLevelsOptions.length > 0 && (accessGroupLevel[demurrageFormView.groupLevel] == 'Y' || !accessGroupLevel.includes('Y'))) &&
                    <>
                        <div className='col-lg-6 mb-3'>
                            <Form.Group controlId='carrierHaulage.userRemark'>
                                <Form.Label className='fs--1'>
                                    {t('resource_2:approval_level')}
                                </Form.Label>
                                <Form.Select
                                    aria-label="Config"
                                    className="fs--1"
                                    size="lg"
                                    value={watch("selectedApprovalLevel") ?? ""}
                                    disabled={state.approvalLevelsOptions.length <= 1}
                                    onChange={(e: any) => {
                                        setValue("selectedApprovalLevel", e?.target?.value)
                                    }}
                                >
                                    <option value="" hidden={true}>
                                        Select Approval Level
                                    </option>
                                    {
                                        state.approvalLevelsOptions.map(({ label, value }: { label: string, value: number }) => (
                                            <option key={value} value={value}>
                                                {label}
                                            </option>
                                        ))
                                    }
                                </Form.Select>
                            </Form.Group>
                        </div>
                    </>
                }
                <div className='col-lg-6 mb-3'>
                    <Form.Group controlId='carrierHaulage.userRemark'>
                        <Form.Label className='fs--1'>
                            {t('resource_2:userRemark')}
                        </Form.Label>
                        <Form.Control
                            className={'fs--1 form-control'}
                            value={state.userRemarks}
                            maxLength={200}
                            as='textarea'
                            {...register('userRemarks')}
                            onChange={(e) => {
                                setUserRemarks(e.target.value);
                                dispatch(setDirty());
                            }}

                            disabled={
                                profileDetails.partnerType == 'liner' ||
                                state.disableFields ||
                                demurrageFormView.status === 'Completed'
                            }
                        />
                    </Form.Group>
                </div>

                {rbac.rbacDetails.doExtApproveReject === 'Y' ||
                    state.disableFields ? (
                    <div className='col-lg-6 mb-3'>
                        <Form.Group controlId='carrierHaulage.rejectionRemark'>
                            <Form.Label className='fs--1'>
                                {t('resource_1:rejectRemark')}
                            </Form.Label>
                            <Form.Control
                                className={'fs--1 form-control'}
                                value={state.remarks}
                                as='textarea'
                                onChange={(e) => {
                                    setRemarks(e.target.value);
                                    dispatch(setDirty());
                                }}
                                disabled={
                                    demurrageFormView.status == 'Completed' || demurrageFormView.status?.includes('Rejected')
                                        ? true
                                        : rbac.rbacDetails.doExtApproveReject === 'Y'
                                            ? false
                                            : state.disableFields
                                }
                            />
                        </Form.Group>
                    </div>
                ) : (
                    <></>
                )}
            </div>
            {state.showDoUploadStatus && (
                <>
                    <div className="row">
                        <div className='col-lg-6 mb-3'>
                            <Form.Group controlId='carrierHaulage.doUploadStatus'>
                                <Form.Label className='fs--1 d-flex align-items-center'>

                                    DO Upload Status
                                    <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        title='Status of DO sent to Terminal, if failed then switch app to reprocess'
                                        className='ms-2'
                                    />
                                </Form.Label>

                                <Form.Control
                                    className='fs--1 form-control'
                                    value={state.doUploadStatus}
                                    maxLength={200}
                                    {...register('doUploadStatus')}
                                    onChange={(e) => {
                                        setDoUploadStatus(e.target.value);
                                        dispatch(setDirty());
                                    }}
                                    disabled={true}

                                />

                            </Form.Group>
                        </div>

                        <div className='col-lg-6 mb-3'>
                            <Form.Group controlId='carrierHaulage.doIntegrationRemarks'>
                                <Form.Label className='fs--1'>
                                    DO Integration Remarks
                                </Form.Label>
                                <Form.Control
                                    className={'fs--1 form-control'}
                                    value={state.doIntegrationRemarks}
                                    maxLength={200}
                                    as='textarea'
                                    {...register('doIntegrationRemarks')}
                                    onChange={(e) => {
                                        setDoIntegrationRemarks(e.target.value);
                                        dispatch(setDirty());
                                    }}

                                    disabled={true}

                                />
                            </Form.Group>
                        </div>
                    </div>
                </>
            )}
            <div className='d-flex justify-content-center align-items-center mt-4'>
                {
                    dataCountry === blCountry &&
                        rbac.rbacDetails.doExtApproveReject === 'Y' &&
                        !(
                            state.isProcessing === 'Y' &&
                            !linerDocs?.find((i) => i.docId == 206)?.serverPath &&
                            !linerDocs?.find((i) => i.docId == 206)?.id
                        ) ? (
                        <>
                            {
                                instructionList
                                    .filter(
                                        (v: any) =>
                                            v?.docId === demurrageFormView?.dndInstructionId
                                    )
                                    .map((u: any) => u?.event === 'Completed')
                                    .includes(true)
                                    ||
                                    (demurrageFormView.status == 'Completed' || demurrageFormView.status?.includes('Rejected')) ? (
                                    <></>
                                ) : (
                                    <>
                                        <div className='d-flex justify-content-center align-items-center'>
                                            {(accessGroupLevel[demurrageFormView.groupLevel] == 'Y' || !accessGroupLevel.includes('Y')) && <>
                                                {/* {(approveRejectAccess || !releaseInstructionConfig?.fields?.hideApproveRejectAccess) && (
                                                    <> */}
                                                        <Button
                                                            disabled={
                                                                demurrageFormView?.status === 'Completed' ||
                                                                    demurrageFormView?.status?.includes('Rejected')
                                                                    ? state.disableFields
                                                                    : false
                                                            }
                                                            onClick={() => {
                                                                onApproveReject('A', 'DO_EXTENSION');
                                                            }}
                                                            variant='success'
                                                            className='me-2 approve'
                                                            size='sm'>
                                                            <FontAwesomeIcon
                                                                icon={faCheck}
                                                                className='me-2 approve'
                                                            />
                                                            {t('resource_1:approve')}
                                                        </Button>

                                                        <Button
                                                            variant='danger'
                                                            className='reject me-2'
                                                            size='sm'
                                                            disabled={
                                                                demurrageFormView?.status === 'Completed' ||
                                                                    demurrageFormView?.status?.includes('Rejected')
                                                                    ? state.disableFields
                                                                    : false
                                                            }
                                                            onClick={() => {
                                                                onApproveReject('R', 'DO_EXTENSION');
                                                            }}>
                                                            <FontAwesomeIcon
                                                                icon={faTimes}
                                                                className='me-2   reject'

                                                            />
                                                            {t('resource_1:reject')}
                                                        </Button>
                                                    {/* </>
                                                )} */}
                                                {rbac.rbacDetails.snoozeCUD === 'Y' && !location.pathname.includes('/bl') ? <SnoozedToButton blNum={AESDecrypt(blNum)} blEventId={blEventId_docInsDashboard} /> : ""}
                                            </>
                                            }
                                        </div>
                                    </>
                                )}
                        </>
                    ) : (
                        !state.disableFields && (
                            <div className='d-flex justify-content-center align-items-center'>
                                {state.submitFlag ? (
                                    <Lottie
                                        animationData={infiniteLoop}
                                        loop={true}
                                        style={{ height: '80px', width: '80px' }}
                                    />
                                ) : (
                                    <>
                                        <Button
                                            className='me-2'
                                            variant='falcon-primary'
                                            size='sm'
                                            type='submit'
                                            disabled={(() => {
                                                if (Object.values(state.loadingFileState).some(
                                                    (val) => val != 100 && val != -1 && val != undefined
                                                )) {
                                                    return true
                                                }

                                                if (releaseInstructionConfig?.fields?.showUSCAMessage) {
                                                    if (!state.senderEmail || state.senderEmail?.trim?.() == '') {
                                                        return true
                                                    }
                                                    return !data.list
                                                        .some((v: any) =>
                                                            selectedDate?.[v?.containerNo] ? true : false
                                                        )
                                                }

                                                if (releaseInstructionConfig?.fields?.docAttachmentRequired) {
                                                    const docAttachmentKey = extensionAttData
                                                    const viewFormAttKey = demurrageFormView.extensionAttList
                                                    const mandatoryDocs =
                                                        docAttachmentKey?.list?.filter((x) => x.m) ?? []

                                                    if (
                                                        mandatoryDocs.length > 0 &&
                                                        mandatoryDocs.findIndex((d) => {
                                                            const key =
                                                                d?.dndInstructionAttId ??
                                                                d?.rowNumber ??
                                                                null

                                                            return (
                                                                !selectedAttachmentName?.[key] ||
                                                                ((state.loadingFileState[key] !== 100 ||
                                                                    !serverFilePath[key]) &&
                                                                    ((viewFormAttKey.findIndex(
                                                                        (i) =>
                                                                            i?.docId == d?.docId &&
                                                                            i?.dndInstructionAttId
                                                                    ) == -1) ||
                                                                        state.loadingFileState[key] == -1))
                                                            )
                                                        }) != -1
                                                    ) {
                                                        return true
                                                    }

                                                    if (
                                                        releaseInstructionConfig?.fields
                                                            ?.skipValidatePickUpLocation
                                                    ) {
                                                        const usedContainers = Object.entries(
                                                            selectedPickupLocation
                                                        )
                                                            .filter(
                                                                ([key, val]) =>
                                                                    val && val != '' && key != 'location'
                                                            )
                                                            .map(([key, _]) => key)

                                                        if (usedContainers.length < 1) {
                                                            return true
                                                        }

                                                        if (
                                                            releaseInstructionConfig?.fields
                                                                ?.requirePickupDateForOverstay
                                                        ) {
                                                            return usedContainers.some(
                                                                (c) => !selectedDate?.[c]
                                                            )
                                                        }
                                                    }

                                                    return !PickupLocationValidityFlag
                                                }

                                                if (releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels && oblForm?.pod === 'MYKUA') {
                                                    return false
                                                }

                                                if (releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels && oblForm?.pod === 'MYPEN') {
                                                    if (!state.senderEmail || state.senderEmail?.trim?.() == '') {
                                                        return true
                                                    }

                                                    return !data.list
                                                        .map((v: any) =>
                                                            selectedDate?.[v?.containerNo] &&
                                                                selectedTruckerCode?.[v?.containerNo]
                                                                ? true
                                                                : false
                                                        ).includes(true)
                                                }

                                                if (releaseInstructionConfig?.fields?.mandatoryTruckerCode) {
                                                    if (!state.senderEmail || state.senderEmail?.trim?.() == '') {
                                                        return true
                                                    }

                                                    return !data.list
                                                        .map((v: any) =>
                                                            selectedTruckerCode?.[v?.containerNo]
                                                                ? true
                                                                : false
                                                        )
                                                        .includes(true)
                                                }

                                                if (
                                                    releaseInstructionConfig?.fields?.showPickupLocation ||
                                                    releaseInstructionConfig?.fields
                                                        ?.showIntendedDateAllContainersWhenEditable ||
                                                    releaseInstructionConfig?.fields
                                                        ?.showIntendedDateAllContainersAlways
                                                ) {
                                                    return !PickupLocationValidityFlag
                                                }

                                                return false

                                            })()}>
                                            <FontAwesomeIcon icon={faSave} className='me-2' />
                                            {t('resource_1:submit')}
                                        </Button>
                                        <Button
                                            className='me-2'
                                            variant='falcon-danger'
                                            size='sm'
                                            onClick={resetForm}
                                            style={{ zIndex: 1 }}>
                                            <FontAwesomeIcon icon={faRedo} className='me-2' />
                                            {t('resource_1:reset')}
                                        </Button>
                                        {
                                            rbac.rbacDetails.doExtSaveAsDraft === 'Y' && ((newEvent || recentId?.event == 'Not Submitted') && (state.currStatus != 'Submitted') && (!state.currStatus.includes('Rejected'))) &&
                                            <Button
                                                className='me-2'
                                                variant='falcon-primary'
                                                size='sm'
                                                type='submit'
                                                onClick={() => {
                                                    setIsDraft(true)
                                                }}
                                                disabled={
                                                    (
                                                        () => {

                                                            // if loading
                                                            if (Object.values(state.loadingFileState).some(
                                                                (val) => val != 100 && val != -1 && val != undefined
                                                            )) return true

                                                            if (Object.values(selectedPickupLocation).length < 2
                                                            ) return true

                                                            if (state.userRemarks.trim() != '')
                                                                return false

                                                            if (releaseInstructionConfig?.fields?.showIntendedDateContainerField) {
                                                                if (state.senderEmail && state.senderEmail?.trim?.() != '')
                                                                    return false

                                                                if (data.list
                                                                    .findIndex((v: any) =>
                                                                        selectedTruckerCode?.[v?.containerNo] &&
                                                                        selectedTruckerCode?.[v?.containerNo].trim() != ''
                                                                    ) != -1)
                                                                    return false
                                                            }

                                                            if (releaseInstructionConfig?.fields?.showUSCAMessage || releaseInstructionConfig?.fields?.showMalaysiaSpecificLabels) {
                                                                if (state.senderEmail && state.senderEmail?.trim?.() != '')
                                                                    return false

                                                                if (data.list
                                                                    .findIndex((v: any) =>
                                                                        selectedDate?.[v?.containerNo]
                                                                    ) != -1)
                                                                    return false
                                                            }

                                                            return false
                                                        }
                                                    )()
                                                }>
                                                <FontAwesomeIcon icon={faFolder} className='me-2' color='#f5822a' />
                                                {t('resource_3:saveAsDraft')}
                                            </Button>}
                                    </>
                                )}


                            </div>
                        )
                    )}
                {
                    (state.currStatus == 'Submitted' || state.currStatus?.includes('Rejected') || state.currStatus == 'Draft') &&
                        profileDetails.partnerType != 'liner' &&
                        state.disableFields && (demurrageFormView?.requestedPartnerId == profileDetails?.partnerId) ? (
                        <div className='d-flex justify-content-center align-items-center'>
                            <Button
                                variant='falcon-primary'
                                size='sm'
                                className='me-2'
                                onClick={async () => {
                                    if (
                                        (linerConfig.crrUnpaidHardStop == 'Y'
                                            || linerConfig.crrUnpaidSoftStop == 'Y')) {
                                        dispatch(clearUnpaidData())
                                        const linerId =
                                            profileDetails.partnerType === 'liner'
                                                ? profileDetails.partnerId
                                                : selectedLinerId;

                                        if (await dispatch(getUnpaidInvoice(
                                            { crrPopAttStop: linerConfig.crrPopAttStop, blid: AESDecrypt(blNum) ?? demurrageFormView.blId ?? blidDocHistory, country: blCountry, linerId: linerId, location: null },

                                        )).unwrap().then(
                                            ({ unpaid, attachment }: any) => {
                                                if ((unpaid && unpaid.length > 0) ||
                                                    (attachment && attachment.length > 0)
                                                ) {
                                                    return true
                                                }
                                            }
                                        )) {
                                            navigate(`${getUnprefixedPathname().split('/')[0]}/bl/${encodeURIComponent(
                                                blNum || ''
                                            )}/${AESEncrypt('820')}/unpaid`)
                                            return
                                        }
                                    }
                                    setDisableFields(false);
                                    setIsEdit(true);
                                }}>
                                <FontAwesomeIcon icon={faEdit} className='me-2' />
                                {t('resource_1:edit')}
                            </Button>
                        </div>
                    ) : (
                        <></>
                    )}
            </div>
        </Form>
    )
}

export default DOExtensionForm
